import communi from "../../assets/aboutPage/communi.svg";
import great from "../../assets/aboutPage/great.svg";
import quick from "../../assets/aboutPage/quick.svg";
export const cardData = [
  {
    icon: quick,
    title: "Quick Response",
    para: "Lorem ipsum dolor sit amet vel accumsan liberavisse ex ea nec  concludaturque ndo. Verear",
  },
  {
    icon: great,
    title: "Great Communication",
    para: "Lorem ipsum dolor sit amet vel accumsan liberavisse ex ea nec  concludaturque ndo. Verear",
  },
  {
    icon: communi,
    title: "customer satisfaction",
    para: "Lorem ipsum dolor sit amet vel accumsan liberavisse ex ea nec  concludaturque ndo. Verear",
  },
];
